import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import {
  AdvisorProfileErrorState,
  AdvisorProfileSkeleton,
  AdvisorProfileView,
} from '@/shared/components/advisor-profile';
import { useCurrentFinancialAdvisorProfile } from '@/features/provider-directory/hooks/useFinancialAdvisorProfile';
import { PermissionGate } from '@/features/workspace-sub-delegation';
import {
  PermissionDeniedCard,
  isWorkspacePermissionError,
} from '@/shared/components/sub-delegation';
import { AdvisorInformationTab } from './AdvisorInformationTab';

export const ProfileTabContent = () => {
  const { data: profile, isLoading, isError, error, refetch } =
    useCurrentFinancialAdvisorProfile();

  if (isLoading) {
    return <AdvisorProfileSkeleton />;
  }

  // Backstop: a delegate hitting a workspace-permission 403 sees a graceful
  // denied card instead of the generic retry error state.
  if (isWorkspacePermissionError(error)) {
    return <PermissionDeniedCard feature="this profile" variant="page" />;
  }

  if (isError || !profile) {
    return <AdvisorProfileErrorState onRetry={refetch} />;
  }

  return (
    <Tabs defaultValue="preview" className="w-full">
      <TabsList>
        <TabsTrigger value="preview">Preview</TabsTrigger>
        <TabsTrigger value="information">Information</TabsTrigger>
      </TabsList>

      <TabsContent value="preview" className="mt-6">
        <AdvisorProfileView profile={profile} showServiceProviderActions={false} />
      </TabsContent>

      <TabsContent value="information" className="mt-6">
        {/* Editing the owner's profile requires PROFILE_MANAGEMENT; the
            read-only Preview tab stays visible to any delegate. */}
        <PermissionGate permission="PROFILE_MANAGEMENT" feature="profile management">
          <AdvisorInformationTab profile={profile} />
        </PermissionGate>
      </TabsContent>
    </Tabs>
  );
};
